var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('page-title',{attrs:{"icon":"fas fa-user-tie"}},[_c('translate',[_vm._v("Edit Company")])],1),_vm._v(" "),_c('company-form',{attrs:{"companyId":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }